import { AxiosError } from "axios";

export class MissingIncinerationAuthorizationError extends Error {
  constructor(error: AxiosError) {
    super(error.message);
    this.message = 'error.incineration.authorization';
    this.name = "MissingIncinerationAuthorizationError";
  }
}
